const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addDistribute: ({ commit }, distribute) => commit('add', distribute)
};

const mutations = {
  add: (state, distribute) => {
    state.byId[distribute.id] = distribute;
    if (state.allIds.includes(distribute.id)) return;
    state.allIds.push(distribute.id);
  },
  reset: state => Object.assign(state, getDefaultState())
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
